import {
    EditProductLoadApiFailureAction,
    EditProductLoadApiRequestAction,
    EditProductLoadApiSuccessAction,
    EditProductSelectCategoryAction,
    EditProductSelectPropertyAction,
    EDIT_PRODUCT_LOAD_API_FAILURE,
    EDIT_PRODUCT_LOAD_API_REQUEST,
    EDIT_PRODUCT_LOAD_API_SUCCESS,
    EDIT_PRODUCT_SELECT_CATEGORY,
    EDIT_PRODUCT_SELECT_PROPERTY,
} from 'mk2/apps/bazaar/containers/EditProduct/EditProduct.actions';
import { QualityCounts } from 'mk2/apps/bazaar/schemas';
import {
    MK_REDUX_FORM_CANCEL_PAGE,
    MK_REDUX_FORM_CLOSE_PAGE,
    MKReduxFormCancelPage,
    MKReduxFormClosePage,
} from 'mk2/helpers/form.actions';
import { errorMessage } from 'mk2/reducers/errorMessage';
import { loadingState, LoadingState } from 'mk2/reducers/loadingState';
import { Reducer } from 'redux';

type EditProductActions =
    | EditProductLoadApiRequestAction
    | EditProductLoadApiSuccessAction
    | EditProductLoadApiFailureAction;

export interface EditState {
    productId: number;
    loadingState: LoadingState;
    loadingError: string;
    correctedFields: string[];
    qualityCounts: QualityCounts;
}

export const initialEditState: EditState = {
    productId: null,
    loadingState: LoadingState.INIT,
    loadingError: null,
    correctedFields: [],
    qualityCounts: null,
};

const editReducer: Reducer<EditState> = (state: EditState = initialEditState, action: EditProductActions) => {
    switch (action.type) {
        case EDIT_PRODUCT_LOAD_API_REQUEST:
        case EDIT_PRODUCT_LOAD_API_FAILURE:
            return {
                ...state,
                loadingState: loadingState(state.loadingState, action),
                errorMessage: errorMessage(state.loadingError, action),
            };
        case EDIT_PRODUCT_LOAD_API_SUCCESS:
            return {
                ...state,
                productId: action.response.result.product,
                correctedFields: action.correctedFields,
                loadingState: loadingState(state.loadingState, action),
                errorMessage: errorMessage(state.loadingError, action),
                qualityCounts: action.qualityCounts,
            };
        default:
            return state;
    }
};

export interface State {
    edits: {
        [slug: string]: EditState;
    };
    selectedProperty: string;
    selectedCategory: string;
}

export const initialState: State = {
    edits: {},
    selectedProperty: null,
    selectedCategory: null,
};

const reducer: Reducer<State> = (
    state: State = initialState,
    action:
        | EditProductActions
        | MKReduxFormClosePage
        | MKReduxFormCancelPage
        | EditProductSelectPropertyAction
        | EditProductSelectCategoryAction,
) => {
    switch (action.type) {
        case EDIT_PRODUCT_LOAD_API_REQUEST:
        case EDIT_PRODUCT_LOAD_API_FAILURE:
        case EDIT_PRODUCT_LOAD_API_SUCCESS:
            return {
                ...state,
                edits: {
                    ...state.edits,
                    [action.slug]: editReducer(state.edits[action.slug], action),
                },
            };
        case EDIT_PRODUCT_SELECT_PROPERTY:
            return {
                ...state,
                selectedProperty: action.property,
            };
        case EDIT_PRODUCT_SELECT_CATEGORY:
            return {
                ...state,
                selectedCategory: action.category,
            };
        case MK_REDUX_FORM_CLOSE_PAGE:
        case MK_REDUX_FORM_CANCEL_PAGE:
            // Reset selectedProperty when page is closed
            return {
                ...state,
                selectedProperty: null,
                selectedCategory: null,
            };
        default:
            return state;
    }
};

export default reducer;
